<!-- @format -->

<div class="hmf-mb-m-m hmf-mb-xs hmf-mx-s hmf-mx-m-0">
	<span>
		@if (content?.promotionMessage?.icon) {
			<homefield-icon
				class="hmf-mr-xxs"
				[class]="content?.promotionMessage?.iconClassName"
				width="23px"
				height="23px"
				[name]="content?.promotionMessage?.icon"></homefield-icon>
		}

		@if (brand === 'Gold') {
			<span
				class="info-content hmf-ml-0"
				[class]="content?.promotionMessage?.messageClassName"
				[innerHTML]="content?.promotionMessage?.message | dcsgSanitizeHtml"></span>
		}

		@if (brand === 'Nike') {
			<span
				class="info-content hmf-ml-0"
				[class]="content?.promotionMessage?.messageClassName"
				[innerHTML]="content?.promotionMessage?.messageRebrand | dcsgSanitizeHtml"></span>
		}
	</span>
</div>
